// extracted by mini-css-extract-plugin
module.exports = {"widgetTypeImage":"WidgetTypeImage_widgetTypeImage__2gY92"};